/** 公共菜单组件 props: menu [Array] [{type: '财务评价'，childrens:
['评价1'，'评价2']}] - type: 一级菜单值 - childrens：二级菜单值 tabData [Array]
[{type: '已关联', colnumber: 10, url: '/'}] - type: tab值 - colnumber：布局列数
- url：点击跳转路径 */
<template>
  <el-container class="container-layout">
    <el-header height="35px" class="container-layout-header" v-if="menu.length">
      <div class="menu-f" v-if="menu">
        <el-menu
          :router="router"
          :default-active="defaultMenu.toString()"
          mode="horizontal"
          @select="selectMainMenu"
        >
          <template v-for="(item, i) in menu">
            <el-menu-item
              :key="item.type"
              :index="router ? item.path : i.toString()"
              >{{ item.type }}</el-menu-item
            >
          </template>
        </el-menu>
        <span class="menu-r">
          <slot name="upload"></slot>
        </span>
        <div class="menu-center">
          <slot name="center"></slot>
        </div>
        <div class="menu-right">
          <slot name="right"></slot>
        </div>
      </div>
      <el-col :span="24" v-if="showSecondMenu">
        <div class="menu-c">
          <el-menu
            :default-active="activeIndex"
            mode="horizontal"
            @select="selectMenu"
            :router="childRouter"
          >
            <el-menu-item
              v-for="(item, index) in menu[current].children"
              :index="childRouter ? item.path : index.toString()"
              :key="item"
              >{{ childRouter ? item.name : item }}</el-menu-item
            >
          </el-menu>
        </div>
      </el-col>
    </el-header>
    <el-container
      class="container-layout-content"
      :class="{ modeldatainfo: menu.length }"
    >
      <el-aside v-if="showAside" width="230px">
        <slot name="aside"></slot>
      </el-aside>
      <el-main class="container-el-main">
        <slot name="main"></slot>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import isEmpty from 'lodash/isEmpty';

export default {
  props: {
    menu: {
      type: Array,
      default() {
        return [];
      }
    },
    router: Boolean,
    childRouter: Boolean,
    defaultMenu: {
      type: Number,
      default: 0
    },
    showAside: {
      type: Boolean,
      default: true
    },
    showActiveIndex: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      activeIndex: this.showActiveIndex ? '0' : '-1',
      current: this.defaultMenu || 0
    };
  },
  computed: {
    showSecondMenu() {
      return !isEmpty(
        this.menu[this.current] && this.menu[this.current].children
      );
    }
  },
  methods: {
    selectMainMenu(i) {
      this.current = i;
      this.$emit('selectMainMenu', i);
    },
    goUrl(url) {
      this.$router.push(url);
    },
    selectMenu(val) {
      this.$emit('selectMenu', val);
    }
  }
};
</script>
<style lang="less">
.submenu-wrapper {
  .el-menu--popup-bottom-start {
    display: flex;
  }
  .el-menu--popup {
    min-width: 100px;
    padding: 0 5px 5px;
    background-color: @bgColor;

    .el-menu-item {
      background-color: @bgColor;
      color: #fff !important;
    }
    .el-menu-item:hover {
      background-color: @brandColor;
    }
  }
}
</style>
<style lang="less" scoped>
.container-layout {
  // position: absolute;
  // top: 60px;
  // right: 0;
  // left: 0;
  // bottom: 0;

  .container-layout-header {
    padding: 0;
    background-color: rgb(2, 96, 176);
    /deep/.el-menu {
      // background-color: @bgColor;
      .el-menu-item,
      .el-submenu__title {
        height: 35px;
        line-height: 35px;
        color: #fff;
        border-bottom: 0px;
      }
      // .el-menu-item {
      //   height: 35px;
      //   color: #fff;

      //   &.is-active {
      //     background-color: @brandColor;
      //   }
      //   &:hover {
      //     background-color: @brandColor;
      //   }
      // }
    }

    /deep/.el-button {
      color: #fff;
    }
  }

  .container-layout-content {
    position: absolute;
    top: 60px;
    bottom: 0;
    left: 0;
    right: 0;

    & > .el-main {
      overflow-y: auto;
      height: 100%;
      // background: @bgColor;
      //background: rgba(240, 245, 250, 1);
      background: #c8e0f5;
      box-shadow: 0px 3px 5px 0px rgba(4, 0, 0, 0.1);
    }

    .el-aside {
      overflow-y: auto;
      background: @menuColor;
      color: #fff;
    }
  }
  .modeldatainfo {
    position: absolute;
    top: 95px;
    bottom: 0;
    left: 0;
    right: 0;
  }

  .el-header {
    .menu-f {
      position: relative;
      background-color: rgb(2, 96, 176);
      display: flex;
      height: 100%;
      align-items: center;

      .el-menu {
        border-bottom: none;
        background-color: rgb(2, 96, 176);
        color: #fff;
        padding-left: 25px;
        display: flex;
        height: 100%;
        align-items: center;
        .el-menu-item {
          padding: 0 20px;
          height: 27px;
          color: #d0e5f8;
          line-height: 27px;
          text-align: center;
          font-size: 14px;
          &:hover {
            border-bottom: none;
            color: #fff;
            background: #00000019;
            box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.1);
            border-radius: 4px;
          }
        }
        .is-active {
          border-bottom: none;
          color: #fff;
          background: #00000019;
          box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.1);
          border-radius: 4px;
        }
      }

      .el-dropdown {
        margin-left: 4px;
      }
    }
    .menu-r {
      position: absolute;
      right: 15px;
      top: 0;
      height: 35px;
      line-height: 35px;
      color: #dddddd;
      cursor: pointer;
    }

    .menu-center {
      position: absolute;
      left: 300px;
      top: 50%;
      transform: translateY(-50%);
      height: 30px;
      line-height: 30px;
      color: #ffffff;
      cursor: pointer;
      font-size: 14px;
    }

    .menu-right {
      position: absolute;
      right: 10px;
      top: 50%;
      transform: translateY(-50%);
    }

    .menu-c {
      height: 30px;

      .el-menu {
        height: 100% !important;
        background-color: @bgColor;

        .el-menu-item {
          height: 100% !important;
          line-height: 30px !important;
          color: #ffffff;
        }
      }
    }
  }

  .el-container {
    font-size: 12px;

    .el-aside {
      position: relative;

      .aside-el-row {
        background-color: #003e8e;
        height: 20px;
        line-height: 20px;
        text-align: center;
      }
    }

    .container-el-main {
      padding: 20px 26px 26px 26px;
      // border-left: 2px solid #dddddd;
      // position: relative;

      .el-col {
        .title {
          color: #ffffff;
          background-color: #003e8e;
          padding-left: 20px;
          height: 20px;
          line-height: 20px;
        }
      }
    }
  }
}
</style>
